module.exports = __webpack_public_path__ + "img/9788994475134.e8f89a00.jpg";